import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useBadgeTypesQuery } from '@/client/api/badges/badges.query';

export interface BadgeApplicationFiltersState {
  status: string;
  btid: string;
}

interface BadgeApplicationFiltersProps {
  filters: BadgeApplicationFiltersState;
  onChange: (key: keyof BadgeApplicationFiltersState, value: string) => void;
  onClear: () => void;
}

const selectCls =
  'min-w-[140px] rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

const STATUS_OPTIONS = [
  { value: 'under_review', label: 'Under review' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: '', label: 'All statuses' },
];

const BadgeApplicationFilters = ({
  filters,
  onChange,
  onClear,
}: BadgeApplicationFiltersProps) => {
  const { data: types = [] } = useBadgeTypesQuery(true);
  const hasFilters = Boolean(filters.status || filters.btid);

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
      <select
        className={selectCls}
        value={filters.status}
        onChange={(e) => onChange('status', e.target.value)}
        aria-label="Filter by status"
      >
        {STATUS_OPTIONS.map((opt) => (
          <option key={opt.value || 'all'} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <select
        className={selectCls}
        value={filters.btid}
        onChange={(e) => onChange('btid', e.target.value)}
        aria-label="Filter by badge type"
      >
        <option value="">All badge types</option>
        {types.map((t) => (
          <option key={t.btid} value={String(t.btid)}>
            {t.name}
          </option>
        ))}
      </select>

      {hasFilters && (
        <Button type="button" variant="ghost" size="sm" onClick={onClear} className="gap-1">
          <X className="h-3.5 w-3.5" />
          Clear
        </Button>
      )}
    </div>
  );
};

export default BadgeApplicationFilters;
